import content from 'components/widgets/tooltips/InfoModalContent';

// checklist fields
const sectionContent = {
    //ORIGINAL

    original_sea_service: {
        labelId: 'original_sea_service',
        title: '1. Sea Service',
        description:
            'Check this box when you’ve entered all of your sea service',
        // secondaryDescription: '',
        link: '/addseaservice',
        link_text: 'Add Sea Service',
        fields: ['original_sea_service'],
        infoModalContent: content.original_sea_service,
    },
    original_training: {
        labelId: 'original_training',
        title: '2. Training',
        description:
            'Check this box when you’ve entered all of the training required for the original you’re working on',

        link: '/addtraining',
        link_text: 'Add Training',
        fields: ['original_training'],
        infoModalContent: content.original_training,
    },
    original_medical: {
        labelId: 'original_medical',
        title: '3. Medical',
        //default text if no mmld
        description:
            'Check this box when you have submitted your CG-719K/E Application for Medical Certificate to the USCG via MEDAIP@uscg.mil as a pdf',
        fields: ['original_medical'],
        infoModalContent: content.original_medical,
    },

    original_photocopy_twic: {
        labelId: 'original_photocopy_twic',
        title: '4. TWIC',
        description:
            'You need to have a photocopy of a valid TWIC or copy of your most recent TWIC application receipt',

        // secondaryDescription: '',

        link: '/forms/supporting/start',
        link_text: 'Add TWIC Documents',
        fields: ['original_photocopy_twic'],
        infoModalContent: content.original_photocopy_twic,
    },
    original_drug_test: {
        labelId: 'original_drug_test',
        title: '5. Negative Drug Test',
        description:
            'You need to have proof of Drug Testing documentation that is within 185 days of your application in MM-SEAS',
        // secondaryDescription: '',
        link: '/forms/supporting/start',
        link_text: 'Add Drug Test',
        fields: ['original_drug_test'],
        infoModalContent: content.original_drug_test,
    },
    original_proof_us: {
        labelId: 'original_proof_us',
        title: '6. Verification of Identity',
        description:
            'For all original applications, you will need to verify your identity as a US Citizen in one of two ways. You can provide a copy of your unexpired US Passport or your Birth Certificate',
        link: '/forms/supporting/start',
        link_text: 'Add Proof of ID',
        fields: ['original_proof_us'],
        infoModalContent: content.original_proof_us,
    },
    original_oath: {
        labelId: 'original_oath',
        title: '7. Merchant Mariner Oath',
        description:
            'You will need to take your Merchant Mariner Oath typically in front of a Notary',
        link: '/forms/supporting/start',
        link_text: 'Add Oath',
        fields: ['original_oath'],
        infoModalContent: content.original_oath,
    },
    original_fees: {
        labelId: 'original_fees',
        title: '8. Pay.Gov Fees',
        description:
            'You can upload your receipt if you have paid the correct amount on pay.gov, or reach out to MM-SEAS to take care of dealing with pay.gov fees for you',
        secondaryDescription: '',
        link: '/forms/supporting/start',
        link_text: 'Add Fee Receipt',
        fields: ['original_fees'],
        infoModalContent: content.original_fees,
    },

    original_profile: {
        labelId: 'original_profile',
        title: '9. User Profile',
        description:
            'Check the box when you have double checked your MM-SEAS profile and it is accurate. You understand that the profile information is used to complete your CG-719B form which wil be submitted to the USCG National Maritime Center',
        fields: ['original_profile'],
        infoModalContent: content.original_profile,
    },

    //RENEWAL

    renewal_sea_service: {
        labelId: 'renewal_sea_service',
        title: '1. Sea Service',
        description:
            'Check this box when you’ve entered in all of your sea service from the last 5 years',
        link: '/addseaservice',
        link_text: 'Add Sea Service',
        fields: ['renewal_sea_service'],
        infoModalContent: content.renewal_sea_service,
    },
    renewal_training_domestic: {
        labelId: 'renewal_training_domestic',
        title: '2a. Domestic Training',
        //text in component, dependent on sea service days w/in 5 years
        link: '/addtraining',
        link_text: 'Add Training',
        infoModalContent: content.renewal_training_domestic,
    },
    renewal_training_stcw: {
        //using this label_id for the only training checkbox so far... need to update labelId eventually.
        labelId: 'renewal_training',
        title: '2b. STCW Training',
        description:
            'Check this box when you’ve entered all of the STCW training required for the renewal you’re working on',
        link: '/addtraining',
        link_text: 'Add STCW Training',
        fields: ['renewal_training'],
        infoModalContent: content.renewal_training_stcw,
    },
    renewal_training_radar: {
        labelId: 'renewal_training_radar',
        title: '2c. Radar Training',
        //text in component, dependent on sea service days w/in 5 years
        link: '/addtraining',
        link_text: 'Add Training',
        fields: ['renewal_training_radar'],
        infoModalContent: content.renewal_training_radar,
    },
    renewal_medical: {
        labelId: 'renewal_medical',
        title: '3. Medical',
        description:
            'Check this box if your Medical Certificate is already up to date, or when you have submitted your CG-719K/E Application for Medical Certificate to the USCG via MEDAIP@uscg.mil as a pdf',
        fields: ['renewal_medical'],
        infoModalContent: content.renewal_medical,
    },
    renewal_photocopy_mmc: {
        labelId: 'renewal_photocopy_mmc',
        title: '4. Most Recent MMC',
        description: 'To renew you have to upload your most recent MMC',
        //secondaryDescription:'' ,
        link: '/forms/supporting/start',
        link_text: 'Add Most Recent MMC',
        fields: ['renewal_photocopy_mmc'],
        infoModalContent: content.renewal_photocopy_mmc,
    },
    renewal_photocopy_twic: {
        labelId: 'renewal_photocopy_twic',
        title: '5. TWIC',
        description:
            'You need to have a photocopy of a valid TWIC or copy of your most recent TWIC application receipt',
        link: '/forms/supporting/start',
        link_text: 'Add TWIC Documents',
        fields: ['renewal_photocopy_twic'],
        infoModalContent: content.renewal_photocopy_twic,
    },
    renewal_drug_test: {
        labelId: 'renewal_drug_test',
        title: '6. Negative Drug Test',
        description:
            'You need to have proof of Drug Testing documentation that is within 185 days of your application in MM-SEAS',

        link: '/forms/supporting/start',
        link_text: 'Add Drug Test',
        fields: ['renewal_drug_test'],
        infoModalContent: content.renewal_drug_test,
    },
    renewal_fees: {
        labelId: 'renewal_fees',
        title: '7. Pay.Gov Fees',
        link: '/forms/supporting/start',
        link_text: 'Add Fee Receipt',
        fields: ['renewal_fees'],
        infoModalContent: content.renewal_fees,
    },

    renewal_profile: {
        labelId: 'renewal_profile',
        title: '8. User Profile',
        description:
            'Check the box when you have double checked your MM-SEAS profile and it is accurate. You understand that the profile information is used to complete your CG-719B form which wil be submitted to the USCG National Maritime Center',
        fields: ['renewal_profile'],
        infoModalContent: content.renewal_profile,
    },

    //UPGRADE

    upgrade_sea_service: {
        labelId: 'upgrade_sea_service',
        title: '1. Sea Service',
        description:
            'Check this box when you’ve entered in all of your sea service that will help you upgrade',
        link: '/addseaservice',
        link_text: 'Add Sea Service',
        fields: ['upgrade_sea_service'],
        infoModalContent: content.upgrade_sea_service,
    },
    upgrade_training: {
        labelId: 'upgrade_training',
        title: '2. Training',
        description:
            'Check this box when you’ve entered all of the training required for the upgrade you’re working on',
        link: '/addtraining',
        link_text: 'Add Training',
        fields: ['upgrade_training'],
        infoModalContent: content.upgrade_training,
    },
    upgrade_medical: {
        labelId: 'upgrade_medical',
        title: '3. Medical',
        description:
            'Check this box if your Medical Certificate is already up to date for the type of Endorsement you are applying for, or when you have submitted your CG-719K/E Application for Medical Certificate to the USCG via MEDAIP@uscg.mil as a pdf',
        fields: ['upgrade_medical'],
        infoModalContent: content.upgrade_medical,
    },
    upgrade_photocopy_mmc: {
        labelId: 'upgrade_photocopy_mmc',
        title: '4. Most Recent MMC',
        description: 'To renew you have to upload your most recent MMC',
        //secondaryDescription:'' ,
        link: '/forms/supporting/start',
        link_text: 'Add Most Recent MMC',
        fields: ['upgrade_photocopy_mmc'],
        infoModalContent: content.upgrade_photocopy_mmc,
    },
    upgrade_photocopy_twic: {
        labelId: 'upgrade_photocopy_twic',
        title: '5. TWIC',
        description:
            'You need to have a photocopy of a valid TWIC or copy of your most recent TWIC application receipt',

        // secondaryDescription: '',

        link: '/forms/supporting/start',
        link_text: 'Add TWIC Documents',
        fields: ['upgrade_photocopy_twic'],
        infoModalContent: content.upgrade_photocopy_twic,
    },
    upgrade_drug_test: {
        labelId: 'upgrade_drug_test',
        title: '6. Negative Drug Test',
        description:
            'You need to have proof of Drug Testing documentation that is within 185 days of your application in MM-SEAS',
        // secondaryDescription: '',
        link: '/forms/supporting/start',
        link_text: 'Add Drug Test',
        fields: ['upgrade_drug_test'],
        infoModalContent: content.upgrade_drug_test,
    },
    upgrade_fees: {
        labelId: 'upgrade_fees',
        title: '7. Pay.Gov Fees',
        description:
            'You can upload your receipt if you have paid the correct amount on pay.gov, or reach out to MM-SEAS to take care of dealing with pay.gov fees for you',
        secondaryDescription: '',
        link: '/forms/supporting/start',
        link_text: 'Add Fee Receipt',
        fields: ['upgrade_fees'],
        infoModalContent: content.upgrade_fees,
    },

    upgrade_profile: {
        labelId: 'upgrade_profile',
        title: '8. User Profile',
        description:
            'Check the box when you have double checked your MM-SEAS profile and it is accurate. You understand that the profile information is used to complete your CG-719B form which wil be submitted to the USCG National Maritime Center',
        fields: ['upgrade_profile'],
        infoModalContent: content.upgrade_profile,
    },
};

export default sectionContent;
